import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  addBlackScholesReport,
  blackScholesDetails,
  editBlackScholesReport,
  getAllBlackScholes,
  getAllGrantsForBlackScholes,
  getEditDetails,
  approveBlackScholesReport,
  deleteBlackScholesReport,
} from "../api/black-scholes";
import { BlackScholesReport } from "../types/blackScholes";

export function useGetGrantsForBlackScholes() {
  return useQuery({
    queryKey: ["getsAllGrantsForBlackScholes"],
    queryFn: getAllGrantsForBlackScholes,
  });
}

export function useBlackScholesData() {
  return useMutation({
    mutationKey: "blackScholesData",
    mutationFn: blackScholesDetails,
  });
}

export function useAddBlackScholesReport() {
  return useMutation({
    mutationKey: "addBlackScholesReport",
    mutationFn: addBlackScholesReport,
  });
}

export function useEditBlackScholesReport() {
  return useMutation({
    mutationKey: "editBlackScholesReport",
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      editBlackScholesReport(id, data),
  });
}

export function useGetBlackScholesReportDetails(id?: string) {
  return useQuery({
    queryKey: ["getBlackScholesReportDetails", id],
    queryFn: () => getEditDetails(id),
    enabled: !!id,
  });
}

export function useGetAllBlackScholes() {
  return useQuery({
    queryKey: "getAllBlackScholes",
    queryFn: async () => {
      const response = await getAllBlackScholes();
      return response as BlackScholesReport[];
    },
  });
}

export function useApproveBlackScholesReport() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: "approveBlackScholesReport",
    mutationFn: approveBlackScholesReport,
    onSuccess: () => {
      queryClient.invalidateQueries("getAllBlackScholes");
    },
  });
}

export function useDeleteBlackScholesReport() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: "deleteBlackScholesReport",
    mutationFn: deleteBlackScholesReport,
    onSuccess: () => {
      queryClient.invalidateQueries("getAllBlackScholes");
    },
  });
}
